import React from 'react';

import { Box, Link, Typography } from '@gogame/components';

import { useExportTemplate } from 'Templates';

import { TEMPLATE_TAPJOY_BID_UPDATE } from 'scenes/TapjoyBidUpdate/constants';

export default () => {
  const [exportTemplate] = useExportTemplate({
    name: TEMPLATE_TAPJOY_BID_UPDATE,
  });

  const handleExportTemplate = async () => exportTemplate();

  return (
    <Box align={'center'} justifyContent={'center'}>
      <Typography>
        <Link onClick={handleExportTemplate}>
          Export Tapjoy bid update template
        </Link>
      </Typography>
    </Box>
  );
};
